import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { ApiService } from '../api.service';
import { UserService } from '../user.service';
import { catchError, map } from 'rxjs/operators';
import { saveAs } from 'file-saver';

export type ExportResult = { status: 'downloaded' } | { status: 'dialog-required' };

@Injectable({
  providedIn: 'root',
})
export class ExportFormatsApiService {
  constructor(
    private http: HttpClient,
    private apiService: ApiService,
    private userService: UserService
  ) { }

  getExportFormat(formatParam: string): Observable<ExportResult> {
    const apiUrl = `${this.apiService.API_URL
      }/patrons/${this.userService.getUserId()}/user-history/generate-report?extension=${formatParam}`;
    return this.http.get(apiUrl, { observe: 'response', responseType: 'blob' }).pipe(
      map((response: HttpResponse<Blob>): ExportResult => {
        if (response.status === 200) {
          const fileName = response.headers.get('content-disposition').split(';')[1].trim().split('=')[1];
          const blob = new Blob([response.body]);
          saveAs(blob, fileName);
          return { status: 'downloaded' };
        }
        if (response.status === 202) {
          return { status: 'dialog-required' };
        }
      }),
      catchError((error: HttpErrorResponse) => {
        throw error.message;
      })
    );
  }
}
